import {Undef} from 'app/interface';
import {getGemSettingsFeature} from 'app/utils/config/getGemSettingsFeature';
import {GemSettings} from 'app/utils/config/interface';
import {InstituteConfig} from 'interfaces/ebspk/institutes/instituteConfig';
import {InstitutesSettingsConfig} from 'interfaces/ebspk/institutes/institutesSettingsConfig';

export function getPreferredInstituteConfig(preferredInstituteNumber: Undef<string>, gemSettings: GemSettings): Undef<InstituteConfig> {
    if (preferredInstituteNumber !== undefined) {
        const institutes = getGemSettingsFeature<InstitutesSettingsConfig>(gemSettings, 'institutes')?.institutes;
        return institutes?.[preferredInstituteNumber];
    }
}
